<script>
import { mapGetters } from "vuex";

import leave from "@/mixins/leave";
import medicalSpecialtyService from "@/services/medical-specialty";
import Spinner from "@/components/ui/Spinner";
import InputTag from "@/components/ui/InputTag";

export default {
  name: "ModalMedicalSpecialty",
  mixins: [leave],

  components: {
    Spinner,
    InputTag,
  },

  props: {
    showDialogModal: {
      type: Boolean,
    },
    currentMedicalSpecialty: {
      type: Object,
    },
  },

  data() {
    return {
      isLoading: false,
      isPosting: false,
      specialtyId: null,
      specialty: {},
      isFetchingSpecialty: false,
      isUpdate: !!this.currentMedicalSpecialty?._id,
      isShowed: this.showDialogModal,
    };
  },

  computed: {
    ...mapGetters(["isAdmin", "isDoctor"]),
  },

  created() {
    if (this.isUpdate) {
      this.specialty = this.currentMedicalSpecialty;
    }
  },

  mounted() {
    document.addEventListener("keyup", this.escape);
  },

  beforeDestroy() {
    document.removeEventListener("keyup", this.escape);
  },

  methods: {
    escape(event) {
      if (event.keyCode == 27) this.close();
    },

    submit() {
      if (this.isUpdate) {
        this.updateMedicalSpecialty();
      } else {
        this.creteMedicalSpecialty();
      }
    },

    creteMedicalSpecialty() {
      this.isPosting = true;

      medicalSpecialtyService
        .createMedicalSpecialty(this.specialty)
        .then((specialty) => {
          this.specialtyId = specialty._id;
          this.$bus.$emit("medical-specialty-created", specialty);
          this.close();
        })
        .catch(() => {
          this.isPosting = false;
        });
    },

    updateMedicalSpecialty() {
      this.isPosting = true;

      medicalSpecialtyService
        .updateMedicalSpecialty(this.specialty)
        .then((specialty) => {
          this.specialtyId = specialty._id;
          this.$bus.$emit("medical-specialty-updated", specialty);
          this.close();
        })
        .catch(() => {
          this.isPosting = false;
        });
    },

    close() {
      this.isPosting = false;
      this.isShowed = false;
      this.$emit("close");
    },
  },
};
</script>

<template lang="pug">
    ValidationObserver(v-slot="{handleSubmit}")
      form.modal(@submit.prevent="handleSubmit(submit)")
        header.modal__header
          h2.modal__title Especialidad Médica
          .modal__actions
            el-button(type="info" @click="close()") Cancelar
            el-button.border(type="primary" native-type="submit" :loading="isPosting") Guardar
        p.modal__subtitle Los campos con (*) son obligatorios
        .modal__content(v-if="isFetchingSpecialty")
          spinner
        .modal__content
          .modal__block
            .modal__section
              .modal__sign.sign
                .sign__icon
                  micon(name="assignment")
                h3.sign__title Detalle
              article.modal__fields
                .modal__row
                  fieldset.modal__field
                    label.label * Nombre
                    ValidationProvider(name="Name" rules="required" v-slot="{ errors }")
                      el-input(v-model="specialty.name")
                      span.has-error {{errors[0]}}
                .modal__row     
                  fieldset.modal__field
                    ValidationProvider(name="Abbreviation" rules="required" v-slot="{ errors }")
                      label.label * Abreviación
                      el-input(v-model="specialty.abbreviation")
                      span.has-error {{errors[0]}}
                .modal__row      
                  fieldset.modal__field
                    ValidationProvider(name="ID externo" rules="required" v-slot="{ errors }")
                      label.label * ID externo
                      el-input(v-model="specialty.publicId")                          
                      span.has-error {{errors[0]}}
</template>

<style lang="scss" scoped>
.location {
  .micon {
    margin-right: 10px;
  }
}

.modal {
  z-index: 9999;
}

.event-detail-modal {
  h2 {
    font-weight: bold;
    margin-bottom: 20px;
  }

  h3 {
    margin: 0 0 20px;
  }

  .form-item {
    display: flex;
    flex-direction: column;
    margin-bottom: 30px;

    .description {
      word-break: break-word;
      font-weight: bold;
      color: $primary;
      margin-bottom: 10px;
    }

    .response {
      margin-left: 20px;
      display: list-item;
      list-style-type: "→ ";
    }
  }

  .view-task {
    padding: 1rem;
  }
}

@media (min-width: 446px) {
  .container {
    flex-direction: row !important;
    justify-content: space-between;
  }

  .betweenStreet {
    width: 48.5% !important;

    &:last-child {
      margin-top: 0 !important;
    }
  }
}
</style>
